"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.instantiatePreactComponents = exports.initializeApp = exports.bindPreactComponents = void 0;

var _initialiseComponent = _interopRequireDefault(require("./initialiseComponent"));

var _globals = require("@insided/shared/utils/globals");

var _publish = _interopRequireDefault(require("@insided/deprecated-components/tracker/publish"));

var _bootstrap = require("@insided/shared/bootstrap");

var instantiatePreactComponents = (0, _bootstrap.createComponentInstantiator)('[data-preact]', _initialiseComponent.default, 'preact');
exports.instantiatePreactComponents = instantiatePreactComponents;
var bindPreactComponents = (0, _bootstrap.createComponentBinder)(instantiatePreactComponents);
exports.bindPreactComponents = bindPreactComponents;

var initializeApp = function initializeApp() {
  window.insided = {
    initialiseComponent: _initialiseComponent.default,
    bindPreactComponents: bindPreactComponents,
    trackEvent: _publish.default.trackEvent,
    publish: _globals.publish
  }; // Initialize components

  bindPreactComponents(document); // Set up global publishers

  (0, _bootstrap.addGlobalPublishers)();
};

exports.initializeApp = initializeApp;